import i18n from 'utils/i18n';
import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object().shape({
    client_id: Yup.string().required(i18n.t('errors.required')),
    client_secret: Yup.string().required(i18n.t('errors.required')),
    google_calendar_api_key: Yup.string().required(i18n.t('errors.required')),
  });
